export class CreateApplicationRequest {
  companyId: number | null = null
  companyName = ''
  contactFirstName = ''
  contactLastName = ''
  email = ''
  phone = ''
  internalBankNotes = ''
  bankNotes = ''
}
